import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Col, Container, Row } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import Form from "react-bootstrap/Form";
import axios from 'axios';
import { getApiUrl } from '../../config/api';
import { toast } from 'react-toastify';

const ChoosePlanModal = (props) => {
  // Determine request type and ref_id from props
  const requestType = props.requestType || "subscription"; // "subscription" or "partner"
  const refId = props.refId || null; // subscription_id or partner_id

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    planType: props.plan || "",
    comments: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // Update planType when props.plan changes
  useEffect(() => {
    if (props.plan) {
      setFormData(prev => ({
        ...prev,
        planType: props.plan
      }));
    }
  }, [props.plan]);

  // SIMPLE VALIDATOR
  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Enter a valid email.";

    if (!formData.mobileNumber.trim())
      newErrors.mobileNumber = "Mobile number is required.";
    else if (!/^[0-9]{10}$/.test(formData.mobileNumber))
      newErrors.mobileNumber = "Enter a valid 10-digit number.";

    if (!formData.planType.trim())
      newErrors.planType = "Select a project type.";

    return newErrors;
  };

  // HANDLE INPUT
  const handleChangeInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    setErrors({ ...errors, [e.target.name]: "" });
  };

  // SUBMIT FORM
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);
    setSubmitSuccess(false);

    try {
      // Determine API endpoint based on request type
      const apiEndpoint = requestType === 'partner' 
        ? 'api/public/partner' 
        : 'api/public/subscription';
      
      // Prepare request payload
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        mobile: formData.mobileNumber.trim(),
        project_details: formData.comments.trim() || '',
      };

      // Add ref_id based on request type
      if (refId) {
        if (requestType === 'partner') {
          payload.partner_id = refId;
        } else {
          payload.subscription_id = refId;
        }
      }

      // Make API call
      const response = await axios.post(
        getApiUrl(apiEndpoint),
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        }
      );

      if (response.data.success) {
        setSubmitSuccess(true);
        toast.success(
          response.data.message || 
          `${requestType === 'subscription' ? 'Subscription' : 'Partner program'} request submitted successfully. We will contact you shortly.`
        );
        
        // Reset form
        setFormData({
          name: "",
          email: "",
          mobileNumber: "",
          planType: props.plan || "",
          comments: "",
        });
        
        // Close modal after 2 seconds
        setTimeout(() => {
          props.onHide();
          setSubmitSuccess(false);
        }, 2000);
      } else {
        toast.error(
          response.data.message || 
          `Failed to submit ${requestType} request. Please try again.`
        );
      }
    } catch (error) {
      console.error('Form submission error:', error);
      
      if (error.response) {
        const { status, data } = error.response;
        
        if (status === 422) {
          // Validation errors
          if (data.errors) {
            const apiErrors = {};
            Object.keys(data.errors).forEach(key => {
              // Map API field names to form field names
              if (key === 'mobile') {
                apiErrors.mobileNumber = Array.isArray(data.errors.mobile) 
                  ? data.errors.mobile[0] 
                  : data.errors.mobile;
              } else if (key === 'project_details') {
                apiErrors.comments = Array.isArray(data.errors.project_details) 
                  ? data.errors.project_details[0] 
                  : data.errors.project_details;
              } else {
                apiErrors[key] = Array.isArray(data.errors[key]) 
                  ? data.errors[key][0] 
                  : data.errors[key];
              }
            });
            setErrors(apiErrors);
          }
          toast.error(data.message || 'Please check the form and try again.');
        } else {
          toast.error(
            data.message || 
            `Failed to submit ${requestType} request. Please try again.`
          );
        }
      } else if (error.request) {
        toast.error('Network error. Please check your connection and try again.');
      } else {
        toast.error('An error occurred. Please try again later.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <>
      <Modal
        show={props.show}
        centered
        size="md"
        fullscreen={true}
        onHide={props.onHide}
        animation={true}
      >
        <Modal.Header>
          <Button
            variant="text"
            className="close text-white"
            onClick={props.onHide}
            backgroundColor="transparent"
            color="#ffffff"
            hoverBackgroundColor="transparent"
            padding="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15 5L5 15"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 5L15 15"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center">
            <h1 className="enroll-modal-title">
               Provide us you Details {" "}
              <span className="theme-color-green">We Will connect </span>{" "}
              With you
            </h1>
            <p className="enroll-modal-desc">
              We deliver excellence from experience. Our services focus on
              <br className="d-none d-lg-block" />
              precision, quality, and proven construction processes.
            </p>
          </div>

          <Container className="mb-5">
            <Row>
              <Col xl={{ span: 10, offset: 1 }}>
                <form noValidate onSubmit={handleSubmit}>
                  <Row>
                    {/* NAME */}
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleChangeInput}
                          className={errors.name ? "is-invalid" : ""}
                        />
                        {errors.name && (
                          <span className="text-danger ms-3">
                            {errors.name}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* EMAIL */}
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleChangeInput}
                          className={errors.email ? "is-invalid" : ""}
                        />
                        {errors.email && (
                          <span className="text-danger ms-3">
                            {errors.email}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    {/* MOBILE */}
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          name="mobileNumber"
                          placeholder="Mobile Number"
                          value={formData.mobileNumber}
                          onChange={handleChangeInput}
                          className={errors.mobileNumber ? "is-invalid" : ""}
                        />
                        {errors.mobileNumber && (
                          <span className="text-danger ms-3">
                            {errors.mobileNumber}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                  </Row>

                  {/* Hidden fields for reference */}
                  <input type="hidden" name="request_type" value={requestType} />
                  {refId && (
                    <input 
                      type="hidden" 
                      name={requestType === 'partner' ? 'partner_id' : 'subscription_id'} 
                      value={refId} 
                    />
                  )}

                  {/* PROJECT DETAILS */}
                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="comments"
                      placeholder="Project Details"
                      value={formData.comments}
                      onChange={handleChangeInput}
                      className={errors.comments ? "is-invalid" : ""}
                    />
                    {errors.comments && (
                      <span className="text-danger ms-3">
                        {errors.comments}
                      </span>
                    )}
                  </Form.Group>

                  {submitSuccess && (
                    <div className="alert alert-success mb-3">
                      {requestType === 'subscription' 
                        ? 'Subscription request submitted successfully!' 
                        : 'Partner program request submitted successfully!'}
                    </div>
                  )}

                  <Button
                    type="submit"
                    className="btn-block-green h-56px mt-md-3 mb-4 mb-md-0"
                    backgroundColor="#677a58"
                    color="#ffffff"
                    hoverBackgroundColor="#5a6a4a"
                    height="56px"
                    disabled={isSubmitting || submitSuccess}
                  >
                    {isSubmitting ? "Submitting..." : submitSuccess ? "Submitted!" : "Submit"}
                  </Button>
                </form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChoosePlanModal;
